import * as React from "react";

import {
  Alert,
  Paper,
  Typography,
  Button,
  Box,
  LinearProgress,
  Check,
  Close,
} from "mpulse-design-system";
import { axiosInstance } from "../../services/axiosUtil";

import DropzoneComponent from "./DropzoneComponent";
import { List, ListItem, ListItemText } from "@mui/material";
import { AudioFile } from "@mui/icons-material";
// import DeleteIcon from "@mui/icons-material/Delete";

import PopupLayout from "../PopupLayout/PopupLayout";
import { styled } from "@mui/material";

const UploadFiles = ({
  setPopupEnabled,
  audioFileMap,
  removeAudioFilesFromList,
}) => {
  const [fileList, setFileList] = React.useState([]);
  const [fileErrors, setFileErrors] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(false);
  const [uploadComplete, setUploadComplete] = React.useState(false);
  const [uploadError, setUploadError] = React.useState(null);
  const controller = new AbortController();

  const upload = (audioFileId, file) => {
    let formData = new FormData();
    formData.append("audiofile", file);
    formData.append("name", file.name);

    setIsLoading(true);

    return axiosInstance
      .put(
        `api/v1/account/audio/upload/${audioFileId}`, //url
        formData, //data
        {
          headers: { "Content-Type": "multipart/form-data" },
          signal: controller.signal,
        }
      )
      .then((response) => {
        if (response.status === 200) {
          setIsLoading(false);
        }
        return response;
      })
      .catch((error) => {
        return error;
      })
      .finally(() => {
        setIsLoading(false);
        setUploadComplete(true);
      });
  };

  // const deleteUploadedFile = (file) => () => {
  //   fileSplit = file.name.split("."),
  //   _ = fileSplit.pop(),
  //   baseName = fileSplit.pop();
  //   const audioFileId = audioFileMap[baseName].id;
  //   axiosInstance
  //     .put(
  //       `api/v1/account/audio/upload/${audioFileId}`, //url
  //       { audiofile: "", name: file.name }, //data
  //       { signal: controller.signal }
  //     )
  //     .then((response) => {
  //       if ((response.status = 200)) {
  //         file.isDeleted = true;
  //         handleDeletedFile(file);
  //       }
  //       console.log(response);
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //     });
  // };

  const uploadFiles = async () => {
    let audioFilesToRemove = [];
    for (const i in fileList) {
      const file = fileList[i],
        fileSplit = file.name.split("."),
        _ = fileSplit.pop(),
        baseName = fileSplit.pop();
      const response = await upload(audioFileMap[baseName].id, file);
      if (response.status === 200) {
        audioFilesToRemove.push(audioFileMap[baseName].index);
      } else {
        if (response.response.data && response.response.data.error) {
          setUploadError(response.response.data.error);
        } else {
          setUploadError(
            "One or more files failed to upload. Please try again"
          );
        }
      }
    }
    audioFilesToRemove.sort(function (a, b) {
      return b - a;
    });
    removeAudioFilesFromList(audioFilesToRemove);
  };

  const reset = () => {
    setFileList([]);
    setFileErrors([]);
    setIsLoading(false);
    setUploadComplete(false);
    setUploadError(null);
  };

  const closeWindow = () => {
    reset();
    setPopupEnabled(false);
  };

  const cancelRequest = (file) => {
    controller.abort("Upload cancelled: " + file.name);
  };

  const removeFileFromList = (file) => () => {
    setFileList(fileList.filter((item) => item !== file));
  };

  // const handleDeletedFile = (file) => {
  //   setFileList(fileList.filter((item) => item !== file));
  // };

  const uploadAlert = () => {
    if (uploadComplete) {
      if (uploadError) {
        return <Alert severity="error">{uploadError}</Alert>;
      }
      return (
        <Alert severity="success"> All files were uploaded succesfully </Alert>
      );
    }
    return null;
  };

  const submitButton = (
    <Button variant="contained" onClick={uploadFiles}>
      Submit
    </Button>
  );

  const okButton = (
    <Button variant="contained" onClick={closeWindow}>
      OK
    </Button>
  );

  const cancelButton = (
    <Button variant="contained" onClick={closeWindow}>
      Cancel
    </Button>
  );

  const progressBar = () => {
    if (uploadError) {
      return null;
    } else if (isLoading && !uploadComplete) {
      return <LinearProgress color="secondary" sx={{ flexGrow: "1" }} />;
    } else {
      return (
        <LinearProgress
          color="secondary"
          variant="determinate"
          value={100}
          sx={{ flexGrow: "1" }}
        />
      );
    }
  };

  const cancelRequestButton = (file) => {
    return (
      <Button onClick={cancelRequest(file)}>
        {" "}
        <Close size="sm" />{" "}
      </Button>
    );
  };

  const removeFileFromListButton = (file) => {
    return (
      <Button onClick={removeFileFromList(file)}>
        {" "}
        <Close size="sm" />{" "}
      </Button>
    );
  };

  const removeUploadedFileButton = (file) => {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-end",
          alignItems: "center",
          marginTop: "5px",
        }}
      >
        {/* Per PDEV-2381 this was decided to be redundant. */}
        {/*<Button onClick={deleteUploadedFile(file)}>*/}
        {/*  <DeleteIcon />*/}
        {/*</Button>*/}
        {!uploadError && (
          <Check color="success" sx={{ padding: "0", margin: "0" }} />
        )}
      </Box>
    );
  };

  const listFiles = (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        padding: "15px 5px 15px 5px",
        position: "relative",
        maxHeight: "400px",
      }}
    >
      {fileErrors.map((file) => (
        <StyledAlert key={`${file.name}-error`} severity="error">
          {file.errors[0].message}
        </StyledAlert>
      ))}
      <Typography variant="h2" color="text.primary" sx={{ paddingLeft: "5px" }}>
        {" "}
        Uploaded files{" "}
      </Typography>
      <List sx={{ overflowY: "scroll", maxHeight: "100%" }}>
        {fileList.map((file) => (
          <ListItem
            key={file.name}
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Box sx={{ display: "flex", flexDirection: "row", flexGrow: "1" }}>
              <AudioFile color="secondary" sx={{ paddingRight: "5px" }} />
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  flexGrow: "1",
                }}
              >
                <ListItemText key={file.name}> {file.name} </ListItemText>
                {progressBar()}
              </Box>
            </Box>
            {
              isLoading && !uploadComplete // files loading upload not complete
                ? cancelRequestButton(file) // currently uploading not finished
                : !isLoading && !uploadComplete // not loading or uploading
                ? removeFileFromListButton(file) // remove file from upload list
                : removeUploadedFileButton(file) // upload complete
            }
          </ListItem>
        ))}
      </List>
    </Box>
  );

  return (
    <PopupLayout>
      <Paper
        sx={{
          display: "flex",
          flexDirection: "column",
          margin: "auto",
          width: "400px",
        }}
      >
        <Box sx={{ padding: "15px" }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <Typography variant="h1" color="textPrimary">
              {" "}
              Upload Audio{" "}
            </Typography>
            <Button onClick={closeWindow}>
              {" "}
              <Close size="sm" />{" "}
            </Button>
          </Box>
          <Box>
            <DropzoneComponent
              setFilesUploaded={setFileList}
              setFilesRejected={setFileErrors}
              onDropAccepted={reset}
              audioFileMap={audioFileMap}
            />
            {listFiles}
          </Box>
          {uploadAlert()}
        </Box>
        <Box></Box>
        {!uploadComplete & !uploadError ? (
          <Box
            sx={{
              padding: "15px",
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              backgroundColor: "#E7E9EB",
            }}
          >
            {/* show/hide cancel button */}
            {/* toggle between submit/okay button */}
            {[cancelButton, submitButton]}
          </Box>
        ) : (
          <Box
            sx={{
              padding: "15px",
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              backgroundColor: "#E7E9EB",
            }}
          >
            {okButton}
          </Box>
        )}
      </Paper>
    </PopupLayout>
  );
};

const StyledAlert = styled(Alert)(({ theme }) => ({
  marginBottom: theme.spacing(4),
}));

export default UploadFiles;
